import abstractModel from "../../core/MercatelyModel";
import { MERCATELY_API } from '../../constants/AppConstants';

const resource = `${MERCATELY_API}/tags`;

const model = abstractModel(resource);

model.exportTags = async (params) => {
  const newResource = `${MERCATELY_API}/stats/tags/export_tags`;
  return model.save(params, { path: newResource });
};

export default model;
